import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const KPI_CONFIG = [
  { key: "headcount",             label: "Headcount",          color: "#00ff90"              },
  { key: "hires",                 label: "New Hires",          color: "#60a5fa"              },
  { key: "attritionPct",          label: "Attrition %",        color: "#f87171", suffix: "%" },
  { key: "openReqs",              label: "Open Reqs",          color: "#fbbf24"              },
  { key: "attendanceCompliance",  label: "Attendance %",       color: "#00ff90", suffix: "%" },
  { key: "onLeaveToday",          label: "On Leave Today",     color: "#c084fc"              },
  { key: "ticketsOpen",           label: "Open Tickets",       color: "#fb923c"              },
  { key: "avgRating",             label: "Avg Performance",    color: "#60a5fa"              },
];

export default function AdminFilters({ filters = {}, setFilters, kpis, loading }) {
  const set = (k, v) => setFilters?.(f => ({ ...f, [k]: v }));

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">

      {/* Filter row */}
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        <div>
          <label className={labelCls}>From</label>
          <input type="date" className={inputCls} value={filters.from || ""} onChange={e => set("from", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>To</label>
          <input type="date" className={inputCls} value={filters.to || ""} onChange={e => set("to", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>Location</label>
          <select className={inputCls} value={filters.location || "ALL"} onChange={e => set("location", e.target.value)}>
            <option value="ALL">All Locations</option>
            {["London","Bangalore","Remote","New York","Singapore"].map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Department</label>
          <select className={inputCls} value={filters.department || "ALL"} onChange={e => set("department", e.target.value)}>
            <option value="ALL">All Departments</option>
            {["Engineering","Product","QA","HR","Ops","Finance","Sales"].map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Employment Type</label>
          <select className={inputCls} value={filters.empType || "ALL"} onChange={e => set("empType", e.target.value)}>
            <option value="ALL">All Types</option>
            {["Full-time","Part-time","Contract","Intern"].map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Pay Group</label>
          <select className={inputCls} value={filters.payGroup || "ALL"} onChange={e => set("payGroup", e.target.value)}>
            <option value="ALL">All Groups</option>
            {["Monthly","Weekly","Bi-weekly"].map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
      </div>

      {/* KPI chips */}
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 pt-1 border-t border-white/5">
        {KPI_CONFIG.map(({ key, label, color, suffix = "" }) => (
          <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading ? (
              <div className="h-6 rounded bg-white/10 animate-pulse mb-1" />
            ) : (
              <p className="text-lg font-bold" style={{ color }}>
                {kpis?.[key] != null ? `${kpis[key]}${suffix}` : "—"}
              </p>
            )}
            <p className="text-xs text-white/30 mt-0.5 leading-tight">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}